/** Copyright year for footer and legal notices - calculated automatically */
export const COPYRIGHT_YEAR = new Date().getFullYear();
